<template>
  <div>
    <!-- <progress class="progress is-link" value="25" max="100">25%</progress> -->
    <div class="box">
      <h1 class="page-header">
        Locate Homeowners Association
      </h1>
      <div class="columns">
        <div class="column is-half">
          <div class="field" v-if="!hasTenant">
            <label class="label">Association</label>
            <div class="control">
              <el-select v-model="selectedAssociation" class="arrow-select" filterable placeholder="Select Association" @change="setTenant(selectedAssociation)">
                <el-option v-for="item in associations" :key="item.key" :label="item.label" :value="item.key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="field">
            <label class="label">Association Pin Number</label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Pin Number" :class="{'is-required': noPIN}" @keyup.enter="next()" v-model="Request.PinNumber">
            </div>
          </div>
          <div style="margin-top: 20px;" class="field is-grouped">
            <div class="control">
              <button class="button is-text" @click="cancel()">Cancel</button>
            </div>
            <div class="control">
              <button @click="next()" class="button is-link">Next</button>
            </div>
          </div>
        </div>
        <div v-if="submitted && !showNotFound" style="padding-top: 50px;" class="column is-half has-text-centered opaque">
          <i class="fa fa-refresh fa-spin fa-4x"></i>
          <p>Looking up your Certificate of Property Insurance...</p>
        </div>
        <div v-if="showNotFound" style="padding-top: 50px;" class="column is-half has-text-centered opaque">
          <p>The association was not found, did you enter the correct PIN number?</p>
        </div>
        <div v-if="noPIN" style="padding-top: 50px;" class="column is-half has-text-centered opaque">
          <p>Please enter PIN number.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AssociationPin',
    props: ['Request', 'showNotFound', 'hasTenant', 'agencies'],
    data: function () {
      return {
        submitted: false,
        found: false,
        noPIN: false,
        selectedAssociation: '',
        associations: []
      }
    },
    methods: {
      next() {
        if (!this.Request.PinNumber) {
          this.noPIN = true
        } else {
          this.submitted = true
          this.noPIN = false
          this.$emit('next')
        }
      },
      cancel() {
        this.$emit('cancel')
      },
      setTenant(key) {
        for (let i = 0; i < this.associations.length; i++) {
          if (this.associations[i].key === key) {
            this.$emit('tenantSelected', this.associations[i].tenant)
          }
        }
      },
      getNestedArray(obj) {
        let arr = []
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            let arrayItem = obj[key]
            arrayItem.key = key
            arr.push(arrayItem)
          }
        }
        return arr
      },
      getFlatArray(obj, tenant) {
        let arr = []
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            let associationName = obj[key]
            let item = {
              key: key,
              label: associationName,
              tenant: tenant
            }
            arr.push(item)
          }
        }
        return arr
      }
    },
    created: function () {
      if (this.agencies) {
        let agenciesArray = this.getNestedArray(this.agencies)
        for (let i = 0; i < agenciesArray.length; i++) {
          let assocs = this.getFlatArray(agenciesArray[i].associations, agenciesArray[i].key)
          this.associations = this.associations.concat(assocs)
        }
      }
    }
  }

</script>

<style scoped>
  .arrow-select {
    width: 100%;
  }

  .arrow-select>>>input::-webkit-input-placeholder {
    color: black;
    opacity: .6;
  }

  .arrow-select>>>input:focus {
    border-color: #00d1b2 !important;
  }

  .arrow-select>>>input {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(.375em - 1px);
    padding-left: calc(.625em - 1px);
    padding-right: calc(.625em - 1px);
    padding-top: calc(.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: #fff;
    border-color: #dbdbdb;
    color: #363636;
    -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, .1);
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, .1);
    max-width: 100%;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/request/AssociationPin.vue?64d03ec9